import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ScaleLoader } from "react-spinners";
import Header from "./Header";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

import ApiService from "../services/authservices";
function Refferal() {
  const [referralHistory, setReferralHistory] = useState([]);
  const [currentPageRef, setCurrentPageRef] = useState(1);
  const [totalPagesRef, setTotalPagesRef] = useState(0);
  const [limitRef, setLimitRef] = useState(10);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  useEffect(() => {
    fetchReferralHistory(currentPageRef, limitRef);
  }, [currentPageRef, limitRef]);

  const handlePageChangeRef = (event, value) => {
    setCurrentPageRef(value);
  };

  const fetchReferralHistory = async (page, limit) => {
    try {
      setLoading(true);
      const data = await ApiService.getReferralHistory(page, limit);
      if (data && data.status && Array.isArray(data.referralHistory)) {
        setReferralHistory(data.referralHistory);
        setTotalPagesRef(Math.ceil(data.pagination.totalPages));
        setLoading(false);
      } else {
        setReferralHistory([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching referral history:", error);
      setReferralHistory([]);
      setLoading(false);
    }
  };

  return (
    <div className="recent_depo_main">
      <div className="row">
        <div className="manage_btn_row">
          <span className="home_botstatus_span"> {t("ReferralHistory.")}</span>
          <Link to="/referral">
            <div className="d-flex align-items-center gap-2 cursor-pointer">
              <span className="home_starty_view">{t("BackToReferral")}</span>
              <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
            </div>
          </Link>
        </div>
        <div className="col-lg-12 p-0">
          <div className="refer_third_main pb-0">
            <div className="table-responsive table-borderless home_recent_table">
              {loading ? (
                <div className="loader_main loader_mainChange">
                  <ScaleLoader color="#20A1FD" height={10} width={3} />
                  <p>{t("Loading")}</p>
                </div>
              ) : (
                <>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>{t("SI.no")}</th>
                        <th>{t("UserName")}</th>
                        <th>{t("UserID")}</th>
                        {/* <th>Wallet</th> */}
                        <th>{t("ReferrerID")}</th>
                        {/* <th>Tier</th> */}
                        <th>{t("Date&Time")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {referralHistory.length > 0 ? (
                        referralHistory.map((referral, index) => (
                          <tr key={referral.uuid}>
                            <td>
                              <span>{index + 1}</span>
                            </td>
                            <td>
                              <span>{referral.displayname}</span>
                            </td>
                            <td>
                              <span>{referral.referralCode}</span>
                            </td>
                            {/* <td>
                                                    <span>
                                                    {referral.user_wallet.slice(0, 4) + "..." + referral.user_wallet.slice(-4)}
                                                    </span>
                                                    </td> */}
                            <td>
                              <span>{referral.referrerId}</span>
                            </td>
                            {/* <td>
                                                    <span>{referral.tier.toUpperCase()}</span>
                                                    </td> */}
                            <td>
                              <span>
                                {new Date(referral.createdAt).toLocaleString()}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            <span className="depo_no_record">
                              {t("NoReferralHistoryAvailable")}
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {totalPagesRef > 1 && (
                    <div className="pagination history_pagination_all ">
                      <Stack spacing={2}>
                        <Pagination
                          count={totalPagesRef}
                          page={currentPageRef}
                          onChange={handlePageChangeRef}
                          size="small"
                          sx={{
                            "& .MuiPaginationItem-root": {
                              color: "#fff",
                            },
                            "& .Mui-selected": {
                              backgroundColor: "#ffc630 !important",
                              color: "#000",
                              "&:hover": {
                                backgroundColor: "#ffc630",
                                color: "#000",
                              },
                            },
                            "& .MuiPaginationItem-ellipsis": {
                              color: "#fff",
                            },
                            "& .MuiPaginationItem-icon": {
                              color: "#fff",
                            },
                          }}
                        />
                      </Stack>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Refferal;
